import styled from '@emotion/styled';
import { Button, Input, message, Modal, ModalProps } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { CaptchaInfo } from '../hooks/useShopeeAuthShop';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 10px;
`;
const Text = styled.div`
  font-size: 14px;
  color: var(--fett-text-secondary);
`;
const Num = styled.div`
  font-size: 24px;
  margin-bottom: 8px;
`;
const ConfirmButton = styled(Button)`
  min-width: 180px;
  margin-top: 16px;
`;

export interface ShopeeCaptchaProps extends ModalProps {
  info: CaptchaInfo;
  onConfirm?: (value: RPA.Shopee.RendererEventPayloads.ContinueOTPEventPayload) => void;
}

const ShopeeCaptcha = (props: ShopeeCaptchaProps) => {
  const { info, onConfirm, ...otherProps } = props;
  const [inputValue, setInputValue] = useState<string>('');
  const { t } = useTranslate();

  const handleClick = useCallback(() => {
    if (!inputValue) {
      message.warning(t('authShop.请输入验证码'));
      return;
    }
    onConfirm &&
      onConfirm({
        otp: inputValue,
        taskId: info?.taskId,
        subTaskId: info?.subTaskId,
      });
  }, [info, inputValue, onConfirm, t]);

  const numText = useMemo(() => {
    if (info?.type === 4) {
      return info?.email;
    }
    return info?.phone || info?.email;
  }, [info]);

  return (
    <Modal visible={info?.visible} width={320} footer={null} {...otherProps}>
      <Container>
        <Text>{t('authShop.验证码已发送至')}</Text>
        <Num>{numText}</Num>
        <Input
          placeholder={t('authShop.请输入验证码')}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value.trim())}
        />
        <ConfirmButton type="primary" onClick={handleClick}>
          {t('authShop.确定')}
        </ConfirmButton>
      </Container>
    </Modal>
  );
};

export default ShopeeCaptcha;
